import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

export const CarouselItemContainer = styled.div`
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  color: #1c2b38;
  line-height: 18px;
  display: inline-flex;
  align-items: center;

  .headerPrimeurCarouselItem {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .titlePrimeurCarouselItem {
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 14px;
    color: #2b3d54;
    border-bottom: 1px solid rgba(43, 61, 84, 0.1);
  }

  .content {
    color: #2b3d54;
  }

  .date {
    font-size: 12px;
    opacity: 0.5;
  }

  .info {
    font-size: 14px;
  }

  .name {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
  }

  .value {
    font-size: 14px;
    color: #2b3d54;
    display: flex;
    flex-direction: column;
  }

  .evolution {
    color: ${(props) =>
      props.evolution && props.evolution > 0
        ? '#6cc89f'
        : props.evolution && props.evolution < 0
          ? '#e25d34'
          : '#1c2b38'};
    margin: auto;
    font-weight: 400;
  }

  .iconContainerPrimeurCarouselItem {
    margin-right: 9px;
  }

  .surveyValue {
    min-width: 70px;
    margin-right: 5px;
    height: 70px;
    background-color: rgba(43, 61, 84, 0.05);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px !important;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    border-radius: 8px;
    color: ${(props) => props.theme.colors['dark-two']};
  }

  .carouselRowContent {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;

const CarouselItem = ({
  type,
  created_at,
  store_name,
  store_markets,
  wine_name,
  vintage,
  local_price,
  local_currency,
  evolution
}) => (
  <CarouselItemContainer evolution={evolution}>
    <div className="surveyValue">
      <p className="value">
        {local_price.toLocaleString('fr-FR', {
          style: 'currency',
          currency: local_currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })}
        <span className="evolution">
          {evolution > 0 && '+'}
          {parseInt(evolution * 100, 10)}%
        </span>
      </p>
    </div>
    <div>
      <div className="headerPrimeurCarouselItem">
        <h3 className="titlePrimeurCarouselItem">{type}</h3>
      </div>
      <div className="content">
        <div className="carouselRowContent">
          <div>
            <p className="info">
              <span className="name">{store_name}</span> - {store_markets[0]}
            </p>
            <p className="info">{`${wine_name} - ${vintage}`}</p>

            <p className="date">{moment(created_at).format('DD/MM/YYYY')}</p>
          </div>
        </div>
      </div>
    </div>
  </CarouselItemContainer>
);

export default CarouselItem;
